import React from 'react';
import { useField } from 'formik';
import { Input, Label } from 'reactstrap';

const TextField = (props) => {
  const [field, meta] = useField(props);

  return (
    <div className="TextField form-group">
      {props.label && (
        <Label className="input-label" htmlFor={props.name}>
          {props.label}<sup>*</sup>
        </Label>
      )}
      <Input
        type={props.inputtype || 'text'}
        className={meta.touched && meta.error ? 'is-invalid' : ''}
        id={props.name}
        {...field}
        {...props}
      />
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
};

export default TextField;